module.exports = __webpack_public_path__ + "img/maintenance.235ca767.svg";